import $ from "jquery";

jQuery(function($) {
    // Use event delegation to handle clicks on elements with the class 'open-popup'
    $(document).on("click", ".open-popup", function(e) {
        closeAllPopups();
        e.preventDefault();
        e.stopPropagation();

        // Get the popup identifier from the clicked element
        let popup = $(this).data('popup');
        let $popup = $('#' + popup);

        if ($popup.length > 0) {
            $popup.addClass('active');
            $('.site-overlay').addClass('active');
        }
    });

    // Close popup when 'close-popup' element is clicked
    $(document).on('click', '.close-popup', function(e) {
        e.preventDefault();
        $('.popup').removeClass('active');
        $('.site-overlay').removeClass('active');
    });

    // Prevent click events inside the popup from closing it
    $(document).on('click', '.popup', function(e) {
        e.stopPropagation();
    });

    // Close the popup when clicking outside of it
    $(window).on('click', function(e) {
        $('.popup').removeClass('active');
        $('.site-overlay').removeClass('active');
    });
});

// Function to programmatically open a popup by name
export function openPopup(name) {
    closeAllPopups();
    let $popup = $('#popup-' + name);

    if ($popup.length > 0) {
        $popup.addClass('active');
        $('.site-overlay').addClass('active');

        if ($(window).width() < 767) {
            $('body').append($popup);
        }
    }
}

export function closeAllPopups(){
    $('.popup').removeClass('active');
    $('.site-overlay').removeClass('active');
}